module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dashboard":"Dashboard","previousYear":"Previous year","taxReports":"Tax reports","referral":"Referral discounts"},"fr":{"dashboard":"Vue d\u0027ensemble","previousYear":"Année antérieure","taxReports":"Déclarations d\u0027impôt","referral":"Rabais référence"}}')
  delete Component.options._Ctor
}
